import { Link } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";
import { portalBusinesses } from "@/features/portal/api";
import { portalHref } from "@/features/portal/portal-base";
import type { Column, PortalRecord } from "../collection-card";
import { dash, str } from "../record";
import { BusinessCollection } from "./business-collection";
import { BUSINESS_FIELDS } from "./specs-data";

const ENTITY_LABELS: Record<string, string> = {
  P: "Partnership",
  C: "Corporation",
  L: "LLC",
  T: "Trust / estate",
  O: "Other",
};

/** The Businesses tab for a business client: a list of the client's entities
 * (add/edit the full 433-B profile), each linking to its detail sub-collections. */
export function BusinessTab() {
  const columns: Column<PortalRecord>[] = [
    { header: "Business", cell: (r) => dash(str(r, "business_name")) },
    { header: "Type", cell: (r) => dash(ENTITY_LABELS[str(r, "entity_type")] ?? "") },
    { header: "EIN", cell: (r) => dash(str(r, "ein_label")) },
    {
      header: "Details",
      className: "text-right",
      cell: (r) => (
        <Link
          to={portalHref(`/financials/business/${r.id}`)}
          className="text-primary inline-flex items-center gap-1 text-sm font-medium hover:underline"
        >
          Open <FiChevronRight className="size-4" />
        </Link>
      ),
    },
  ];

  return (
    <div className="grid gap-6">
      <BusinessCollection
        api={portalBusinesses}
        title="Your businesses"
        description="Add each business you own, then open it to enter its accounts, assets, and more."
        addLabel="Add Business"
        noun="Business"
        columns={columns}
        fields={BUSINESS_FIELDS}
      />
    </div>
  );
}
